import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class IdleService {
    private idleTime: any
    private timeout: any;
    private timer$ = new Subject<void>();

    constructor(private ngZone: NgZone) { 
        this.updateIdleTime();
    }

    private updateIdleTime() {
        const timeoutValue = localStorage.getItem('sessionTimeOutMinutes');
        const minutes = timeoutValue ? parseInt(timeoutValue) * 60 * 1000 : 30 * 60 * 1000;
        this.idleTime = minutes;
    }

    startWatching() {
        this.updateIdleTime(); // Update idle time before starting
        this.resetTimer();

        // Listen to user activity
        this.ngZone.runOutsideAngular(() => {
            document.addEventListener('mousemove', () => this.resetTimer());
            document.addEventListener('keydown', () => this.resetTimer());
            document.addEventListener('click', () => this.resetTimer());
            document.addEventListener('scroll', () => this.resetTimer());
        });
    }

    stopWatching() {
        document.removeEventListener('mousemove', () => this.resetTimer());
        document.removeEventListener('keydown', () => this.resetTimer());
        document.removeEventListener('click', () => this.resetTimer());
        document.removeEventListener('scroll', () => this.resetTimer());

        clearTimeout(this.timeout);
    }

    private resetTimer() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
           
            this.timer$.next();
        }, this.idleTime);
    }

    onTimeout() {
        return this.timer$.asObservable();
    }


    refreshIdleTime() {
        this.updateIdleTime();
        this.resetTimer();
    }
}
